import React, { Component } from 'react';
import { connect } from 'react-redux';
import { SEARCH_TYPES, SEARCH_TABS_RESULT, ISort } from '../models';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { IStore } from 'reducers/index';
import { ISortModel } from 'reducers/filters/models';
import { setSort, resetSort } from 'actions/filters';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { isEmptyError } from 'utilities/validate';
import { fetchDocuments, resetDocuments } from 'actions/fcr';
import { displayFilters } from 'actions/filters';
import { setSortForTable } from 'utilities/tables';
import { FiltersInput } from 'modules/filters/components/FiltersInput';
import { FiltersDateInput } from 'modules/filters/components/FiltersDateInput';
import InPageDialog from '../../../../components/page-dialog';
import { Filters } from 'modules/filters/containers/Filters';
import { FiltersSelect } from 'modules/filters/components/FiltersSelect';
import { TabComponent } from 'components/sub-navigation/components/TabComponent';
import { searchFCRStatuses, searchFCROpsStatuses } from 'constants/statuses';
import { GeneralTable } from 'modules/search/components/GeneralTable';
import { DocCols } from './models';
import { Search } from '../Search';
import { FEATURE_TOGGLES } from 'constants/featureToggles';
import { isFeatureEnabled } from 'utilities/util';
import { IFeatureToggleModel } from 'reducers/featureToggle/models';
interface IMapDispatchToProps {
    fetchDocuments: (pageNumber: number, pageSize: number, genericFilter: string) => Promise<void>;
    setSort: (sort: ISortModel) => void;
    resetSort: () => void;
    displayFilters: (hideFilters: boolean, target: string) => void;
    resetDocuments: () => void;
}

interface IMapStateToProps {
    isFetchSearchDataLoading: boolean;
    isFetchSearchDataError: boolean;
    searchPendingError: string | string[],
    documents: any,
    filters: any,
    featureToggles: IFeatureToggleModel[]
}

interface IProps extends RouteComponentProps, IMapStateToProps, IMapDispatchToProps { }

interface IState {
    sorted: any[] | ISort[];
    genericFilter: string;
    withoutFilters: boolean;
    page: number;
    pageSize: number;
    totalCount: number;
    isFetchinProgress: boolean;
    clearFilters: boolean;
    pendingError: string | string[];
    etaFrom: boolean,
    etdFrom: boolean,
    activeTab: number,
    typeOfSearch: string,
    fcr: any[],
    shouldClear: boolean;
    showDialog: boolean;
    hasData: boolean;
    errorMsg: string | null
}
export class _SearchDocuments extends Component<IProps, IState>{
    public generalInputRef: any = React.createRef();
    public tableRef: any = React.createRef();
    public state = {
        sorted: [],
        genericFilter: '',
        withoutFilters: false,
        page: 1,
        pageSize: 10,
        totalCount: 0,
        isFetchinProgress: true,
        etaFrom: false,
        etdFrom: false,
        pendingError: '',
        typeOfSearch: SEARCH_TYPES.FCR,
        activeTab: 3,
        fcr: [],
        clearFilters: false,
        shouldClear: false,
        showDialog: false,
        hasData: false,
        errorMsg: ''
    };
    constructor(props: any) {
        super(props);
    }
    public componentDidMount() {
        let filters = this.props.location.search.includes('targetQuery=jobCostingFiltersDocument') ? true : false;
        if (!filters && this.props.filters && this.props.filters.hasOwnProperty('jobCostingFiltersDocument') && this.props.filters.jobCostingFiltersDocument) {
            filters = true
        }
        this.props.displayFilters(filters, 'jobCostingFiltersDocument')
        this.setState({
            isFetchinProgress: false,
            withoutFilters: filters
        })
    }
    public componentDidUpdate(props: any, state: any) {
        if (this.props.isFetchSearchDataError !== props.isFetchSearchDataError) {
            this.setState({
                showDialog: this.props.isFetchSearchDataError,
                isFetchinProgress: false,
                errorMsg: this.props.searchPendingError.toString() ? this.props.searchPendingError.toString() : 'Request Error'
            })
            if (this.props.location.search) {
                this.props.history.push(this.props.location.pathname);
            }
        }
        if (this.props.documents !== props.documents) {
            this.setData(this.props.documents.result, this.props.documents.page, this.props.documents.pageSize, this.props.documents.totalCount)
            this.setState({
                totalCount: this.props.documents.totalCount
            })
            if (this.props.location.search) {
                this.props.history.push(this.props.location.pathname);
            }
        }
        if (this.props.searchPendingError !== props.searchPendingError &&
            this.props.isFetchSearchDataError === true) {
            const error = isEmptyError(this.props.searchPendingError, 'Server error');
            this.setState({
                pendingError: error,
                isFetchinProgress: false,
                hasData: false
            })
            if (this.props.location.search) {
                this.props.history.push(this.props.location.pathname);
            }
        }
        if (this.state.shouldClear && this.state.shouldClear !== state.shouldClear) {
            this.resetDates()
        }
    }

    public componentWillUnmount(){
        this.props.resetSort()
    }
    
    public render() {
        const isExtraDocumentFeatureEnabled = isFeatureEnabled(FEATURE_TOGGLES.EXTRA_DOCUMENT, this.props.featureToggles);
        const isHblConsumptionEnabled = isFeatureEnabled(FEATURE_TOGGLES.FINOPS_HBL_CONSUMPTION, this.props.featureToggles);
        return (
            <Search triggerFetch={() => this.targetFetch()} withoutFilters={this.state.withoutFilters}>
                <InPageDialog
                    showDialog={this.state.showDialog}
                    type={'error'}
                    message={this.state.errorMsg}
                    closeMethod={() => this.setState({ showDialog: false, errorMsg: '' })} />
                <Filters
                    tableNameKey="jobCostingFiltersDocument"
                    requireFilters={true}
                    genericFilter={this.state.genericFilter}
                    fetchFunction={() => this.fetchReset()}
                    withoutFilters={this.state.withoutFilters}
                    filters={[
                        <FiltersInput
                            key="ReferenceNumbers"
                            name="ReferenceNumbers"
                            label={isExtraDocumentFeatureEnabled ? 'Document number' : (isHblConsumptionEnabled ? 'FCR/HBL number' : 'FCR number')}
                            id="ReferenceNumbers"
                        />,
                        <FiltersSelect
                            key="status"
                            name="status"
                            id="status"
                            label="FinOps Status"
                            options={[
                                ...searchFCRStatuses
                            ]}
                        />,
                        <FiltersSelect
                            key="opsStatus"
                            name="opsStatus"
                            id="opsStatus"
                            label="FinOps Ops. Status"
                            options={[
                                ...searchFCROpsStatuses(isExtraDocumentFeatureEnabled)
                            ]}
                        />,
                        <FiltersInput
                            key="SAPSONumber"
                            name="SAPSONumber"
                            label="SAP SO. Number"
                            id={'soNumber'}
                        />,
                        <FiltersInput
                            key="origin"
                            name="origin"
                            id="origin"
                            label="Origin Service"
                        />,
                        <FiltersInput
                            key="destination"
                            name="destination"
                            id="destination"
                            label="Destination Service"
                        />,
                        <FiltersInput
                            key="consigneeBECode"
                            name="consigneeBECode"
                            id="consigneeBECode"
                            label="Consignee (BE Code)"
                        />,
                        <FiltersInput
                            key="shipperBECode"
                            name="shipperBECode"
                            id="shipperBECode"
                            label="Shipper (BE Code)"
                        />,
                        <FiltersDateInput
                            key="etdFrom"
                            name="etdFrom"
                            id="etdFrom"
                            label="ETD (From)"
                            relatedField="etdTo"
                            type="dateFromTo"
                            setValidity={(val: any) => this.setState({ etdFrom: val })}
                            isInvalid={this.state.etdFrom}
                            value=""
                            withTime={false}
                        />,
                        <FiltersDateInput
                            key="etdTo"
                            name="etdTo"
                            id="etdTo"
                            label="ETD (To)"
                            minValue="etdFrom"
                            setValidity={(val: any) => this.setState({ etdFrom: val })}
                            isInvalid={this.state.etdFrom}
                            type="dateFromTo"
                            withTime={false}
                        />,
                        <FiltersDateInput
                            key="etaFrom"
                            name="etaFrom"
                            id="etaFrom"
                            label="ETA (From)"
                            relatedField="etaTo"
                            setValidity={(val: any) => this.setState({ etaFrom: val })}
                            isInvalid={this.state.etaFrom}
                            type="dateFromTo"
                            withTime={false}
                        />,
                        <FiltersDateInput
                            key="etaTo"
                            name="etaTo"
                            id="etaTo"
                            label="ETA (To)"
                            minValue="etaFrom"
                            setValidity={(val: any) => this.setState({ etaFrom: val })}
                            isInvalid={this.state.etaFrom}
                            type="dateFromTo"
                            withTime={false}
                        />,
                        <FiltersInput
                            key="placeofReceipt"
                            name="PlaceofReceipt"
                            id="PlaceofReceipt"
                            label="Place of Receipt"
                        />,
                        <FiltersInput
                            key="portofLoading"
                            name="PortofLoading"
                            id="PortofLoading"
                            label="Port of Loading"
                        />,
                        <FiltersInput
                            key="portOfDischarge"
                            name="PortOfDischarge"
                            id="PortOfDischarge"
                            label="Port Of Discharge"
                        />,
                        <FiltersInput
                            key="placeOfDelivery"
                            name="PlaceOfDelivery"
                            id="PlaceofDelivery"
                            label="Place of Delivery"
                        />,


                    ]}
                    resetErrors={() => this.resetDates()}
                    disableSubmit={this.state.etaFrom || this.state.etdFrom}
                    resetPaging={(pageNumber: any, pageSize: any) => {
                        this.updatePagination(1);
                        this.setState({
                            page: 1,
                            totalCount: 0,
                            fcr: [],
                            clearFilters: false,
                            hasData: false
                        })
                    }}
                />
                <TabComponent name="search-results" activeTab={0} navLinks={[SEARCH_TABS_RESULT(isHblConsumptionEnabled)[2]]} />
                <GeneralTable
                    id="jobCosting-search-fcr"
                    cols={DocCols(isExtraDocumentFeatureEnabled, isHblConsumptionEnabled)}
                    data={this.state.fcr}
                    pageSize={this.state.pageSize}
                    pageCount={Math.ceil(this.state.totalCount / this.state.pageSize)}
                    isLoading={this.props.isFetchSearchDataLoading}
                    fetchData={this.justFetch}
                    linkAction={(e: any) => {
                        const getId = e.id ? e.id : e.documentNumber;
                        const url = `/job-costing/documents/${getId}/${e.exportJobId}`;
                        this.linkAction(url)
                    }}
                    refFwd={this.tableRef}
                />
            </Search>
        );
    }
    private setData = (data: any, page: number, pageSize: number, totalCount: number) => {
        localStorage.setItem('pageSize-ListTable', pageSize.toString())
        if (isFeatureEnabled(FEATURE_TOGGLES.EXTRA_DOCUMENT, this.props.featureToggles)) {
            if (data && data.length) {
                data = data.map((item: any) => {
                    if (item.fcrNumber && item.fcrOriginalDocNumber && item.fcrOriginalDocNumber.indexOf('/') === -1) {
                        item.fcrOriginalDocNumber = `${item.fcrOriginalDocNumber}/${item.fcrNumber}`;
                    }
                    return item;
                });
            }
        }
        this.setState({
            page,
            pageSize,
            totalCount,
            isFetchinProgress: false,
            hasData: true,
            fcr: data
        })
    }
    private linkAction = (url: string) => {
        return this.props.history.push(url);
    };
    private resetDates = () => {
        if (this.props.documents && this.props.documents.result.length > 0) {
            this.props.resetDocuments()
        }
        this.setState({
            sorted: [],
            page: 1,
            totalCount: 0,
            etaFrom: false,
            etdFrom: false,
            isFetchinProgress: true,
            fcr: [],
            clearFilters: true,
            shouldClear: true,
            hasData: false
        })
    };
    private updatePagination = (page: number = this.state.page) => {
        if (this.tableRef && this.tableRef.current && this.tableRef.current.querySelector('input[type=number]')) {
            this.tableRef.current.querySelector('input[type=number]').value = page;
        }
    }
    private targetFetch = (page: number = this.state.page, pageSize: number = this.state.pageSize) => {
        const tempPageSize: any = localStorage.getItem('pageSize-ListTable jobCosting-search-fcr') ?
        localStorage.getItem('pageSize-ListTable jobCosting-search-fcr') : pageSize
        this.setState({
            isFetchinProgress: true,
            pageSize: tempPageSize
        })
        this.props.fetchDocuments(page, tempPageSize, this.state.genericFilter)
    }
    private fetchReset = (page: number = 1, pageSize: number = 10) => {
        if (!this.state.clearFilters) {
            const p = this.state.page ? this.state.page : page;
            const pS = this.state.pageSize ? this.state.pageSize : pageSize;
            this.setState({
                page: p,
                pageSize: pS,
                isFetchinProgress: true
            });
            this.targetFetch(p, pS)
        }
    };
    private justFetch = (tableData: any) => {
        if (!this.state.isFetchinProgress) {
            let props = {
                page: this.state.page,
                pageSize: this.state.pageSize
            }
            if (tableData) {
                props = {
                    page: tableData.page + 1,
                    pageSize: tableData.pageSize
                }
                this.setState({ sorted: tableData.sorted });
                setSortForTable(tableData.sorted, this.props.setSort)
            } else if (this.state.sorted && this.state.sorted.length) {
                setSortForTable(this.state.sorted, this.props.setSort);
            }
            this.setState({
                page: props.page,
                pageSize: props.pageSize,
                isFetchinProgress: true
            });
            this.targetFetch(props.page, props.pageSize)
        }
        if (tableData) {
            this.setState({
                page: tableData.page + 1,
                pageSize: tableData.pageSize,
            })
        }
    };
}
const mapStateToProps = (state: IStore): IMapStateToProps => ({
    isFetchSearchDataLoading: state.fcr.isFetchDataLoading,
    isFetchSearchDataError: state.fcr.isFetchDataError,
    searchPendingError: state.fcr.detailsPendingError,
    documents: state.fcr.documents,
    filters: state.filters.hideFilters,
    featureToggles: state.featureToggle.featureToggles
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, Action>): IMapDispatchToProps => ({
    fetchDocuments: (pageNumber: number, pageSize: number, genericFilter: string) => dispatch(fetchDocuments(pageNumber, pageSize, genericFilter)),
    setSort: (sort: ISortModel) => dispatch(setSort(sort)),
    resetSort: () => dispatch(resetSort()),
    displayFilters: (hideFilters: boolean, target: string) => dispatch(displayFilters(hideFilters, target)),
    resetDocuments: () => dispatch(resetDocuments())
});
const __SearchD = connect<IMapStateToProps, IMapDispatchToProps, {}, IStore>(mapStateToProps, mapDispatchToProps)(_SearchDocuments);
export const SearchDocuments = withRouter(__SearchD);